import { render, staticRenderFns } from "./Detail-Leave.vue?vue&type=template&id=4b5a773e&scoped=true"
import script from "./Detail-Leave.vue?vue&type=script&lang=js"
export * from "./Detail-Leave.vue?vue&type=script&lang=js"
import style0 from "./Detail-Leave.vue?vue&type=style&index=0&id=4b5a773e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a773e",
  null
  
)

export default component.exports